@let hasDeletions =
  pagesEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal();

<atn-ds-page>
  <atn-ds-table [config]="pagesTableConfig">
    <i
      customTools
      class="atn-icon atn-cluster atn-blue"
      atnDsTooltip="Generated with AI..."
      (click)="generatePagesClickHandler()"
    ></i>
  </atn-ds-table>
</atn-ds-page>

@if (hasDeletions) {
  <atn-ds-confirmation-overlay
    title="Delete page"
    description="Are you sure you want to delete this page?"
    (cancel)="cancelDeletionClickHandler()"
    (confirm)="confirmDeletionClickHandler()"
  />
}

<!-- Page Setup Dialog -->
<atn-mosaic-page-setup-dialog />
<atn-mosaic-page-ai-generate-dialog />
